export default "__VITE_ASSET__b3d60fd4__"